<template>
  <div>
    <div v-if="show" class="blockClick" @click="show = false"></div>
    <nav class="navbar navbar-color is-fixed-bottom transparent">
      <div v-if="show" class="columns is-mobile is-marginless z-index33">
        <div class="column is-offset-5 is-7 has-background-white">
          <div @click.prevent="showModalDemande = true" class="bottomViolet">
            <p class="p_size11 has-text-default">Demander des modifications</p>
          </div>
          <div @click="isRefuseModalActive = true">
            <p class="p_size11 has-text-default">Refuser la proposition</p>
          </div>
        </div>
      </div>
      <div class="columns is-mobile is-marginless ">
        <div class="column padding10 is-5 has-background-white">
          <div class="level is-mobile">
            <div v-if="getNbrSelect" class="level-item is-marginless has-text-centered">
              <p>
                <label>Total de la sélection</label> <br>
                <strong class="has-text-default p_size14 has-text-right">{{solde}}</strong>
                <label>HT</label>
              </p>
            </div>
            <div v-else class="level-item">
              <p class="topViolet bottomViolet">
                <label class="has-text-default">Aucun produit sélectionné</label>
              </p>
            </div>
          </div>
        </div>
        <div class="column padding10 is-7 validiteM">
          <div class="level is-mobile">
            <div class="level-item is-marginless">
              <b-icon
                icon="check-circle"
                size=""
                class="topViolet bottomViolet">
              </b-icon>
            </div>
            <div
              @click="validMail()"
              class="level-item is-size-7 is-marginless">
              <p class="p_size11 has-text-weight-bold">
                Valider la proposition
              </p>
            </div>
            <div
              class="level-item"
              @click="show=!show, $parent.showContact = !show">
              <b-icon v-if="show"
                icon="chevron-up "
                size=""
                class="">
              </b-icon>
              <b-icon v-else
                icon="chevron-down"
                size=""
                class="">
              </b-icon>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <app-modal-demande
      v-if="showModalDemande"
      :date="date"
      :email="email"
      :commercial="commercial"
      :client="client"
      :themeCampagne="themeCampagne"
    />
    <b-modal v-model="isRefuseModalActive">
      <div class="card modalSpace" v-if="proposValide">
        <div class="columns is-mobile is-marginless">
          <div class="media centre">
            <img src="@/assets/img/icon_refu.png" alt="">
          </div>
        </div>
        <div class="columns is-mobile is-marginless">
          <div class="media centre">
            <h2 class="has-text-weight-bold bottomViolet">Refuser la proposition</h2>
          </div>
        </div>
        <div class="columns is-mobile is-marginless has-text-centered">
          <p class="p_size14 bottomViolet">
            Êtes-vous sûr de vouloir refuser la proposition?
          </p>
        </div>
        <div class="bottomViolet">
          <a
            @click="refusMail()"
            class="button buttonPadding is-rounded is-fullwidth
                    is-primary p_size10">
            Refuser la proposition
          </a>
        </div>
        <div class="bottomViolet">
          <a
            @click="isRefuseModalActive = false; showModalDemande = true"
            class="button buttonPadding buttonBorder is-rounded
                    p_size10 has-text-default is-fullwidth">
            Demander des modifications</a>
        </div>
        <div class="bottomViolet" @click="isRefuseModalActive = false">
          <a class="button buttonBorder buttonPadding is-rounded
                    p_size10 has-text-default is-fullwidth">
            Retour
          </a>
        </div>
      </div>
      <div class="card modalSpace" v-else>
        <div class="columns is-mobile is-marginless">
          <div class="media centre">
            <img src="@/assets/img/icon_refu.png" alt="">
          </div>
        </div>
        <div class="has-text-centered">
          <h2 class="has-text-weight-bold bottomViolet">Proposition refusée</h2>
        </div>
        <div class="has-text-centered">
          <p class="p_size14 bottomViolet">Nous avons informé le commercial de votre décision.</p>
        </div>
        <div class="topVert bottomViolet">
          <a
            @click="isRefuseModalActive = false; proposValide = true"
            class="button buttonPadding is-rounded is-fullwidth
                    is-primary p_size10">
            Fermer
          </a>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="isOkModalActive">
      <div class="card modalSpace">
        <div class="columns is-mobile is-marginless">
          <div class="media centre">
            <img src="@/assets/img/icon_valid_opp.png" alt="">
          </div>
        </div>
        <div class="has-text-centered bottomViolet">
          <h2 class="has-text-weight-bold">Proposition validée</h2>
        </div>
        <div class="has-text-centered bottomViolet">
          <p class="p_size14">
            Le commercial a été prévenu de votre validation et reviendra vers vous rapidement
          </p>
        </div>
        <div class="columns is-mobile is-marginless">
          <div class="media centre topVert">
            <div @click="isOkModalActive = false">
            <a class="button buttonPadding is-rounded p_size10 is-primary">Fermer</a>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { sendValidationEmail, sendRefusEmail } from '@/services/mail/sendEmail';
import { mapGetters } from 'vuex';
import { formatNum } from '@/services/opportunite/formatTab';
import modalDemande from './modal/demande';

export default {
  name: 'mobileBlocSelection',
  components: {
    appModalDemande: modalDemande,
  },
  props: ['date', 'commercial', 'client', 'themeCampagne', 'email'],
  data() {
    return {
      show: false,
      showModalDemande: false,
      isRefuseModalActive: false,
      isOkModalActive: false,
      proposValide: true,
    };
  },
  computed: {
    ...mapGetters([
      'getSolde',
      'getNbrSelect',
    ]),
    solde() {
      return formatNum(this.getSolde);
    },
  },
  methods: {
    validMail() {
      this.isOkModalActive = true;
      sendValidationEmail(this.$route.params.id,
        this.commercial, this.client.nom, this.client.societe, this.themeCampagne);
    },
    refusMail() {
      this.proposValide = false;
      sendRefusEmail(this.$route.params.id,
        this.commercial, this.client.nom, this.client.societe, this.themeCampagne);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/composants/blocSelection.vue